var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCycleeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3cb474;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.72,0H17A17,17,0,0,0,0,17V124.72a17,17,0,0,0,17,17H124.72a17,17,0,0,0,17-17V17A17,17,0,0,0,124.72,0ZM100.24,32.08A9.94,9.94,0,1,1,90.13,42,10,10,0,0,1,100.24,32.08ZM120.47,70.9c0,26.89-22.22,48.69-49.6,48.69S21.26,97.77,21.26,70.87,43.47,22.15,70.87,22.14h0a9.94,9.94,0,1,1,0,19.87h-.25c-16.12.13-29.15,13-29.15,28.87s13.16,28.87,29.4,28.87a29.15,29.15,0,0,0,29.39-28.65,1.64,1.64,0,0,1,0-.22,10.12,10.12,0,0,1,20.23,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleeLogo);
export default __webpack_public_path__ + "static/media/cyclee-logo.e87536b3a4e32ecf4b7d3fb08565fa48.svg";
export { ForwardRef as ReactComponent };